import { postRequest, getRequest, putRequest, formDataPutRequest } from "../system/server-call";
// eslint-disable-next-line import/no-cycle
import responseHandler from "../system/server-response-handler";
import {
  setItemToStorage,
  removeItemFromStorage,
  clearStorage,
  encryptObject,
} from "../system";

/**
 *The Auth Service
 *
 *This is used for getting data from server and handling the business logic on that data
 */
//Logging out the user from the app and removing its information from browser
function logout() {
  removeItemFromStorage(process.env.REACT_APP_PAYLOAD);
  clearStorage();
  window.location.reload();
  return Promise.resolve();
}

//Handling the Login response, if user is authenticated then saving
//the jwt token in the local storage
function handleLoginResponse(appPayload) {
  const ciphertext = encryptObject({ ...appPayload });
  setItemToStorage(process.env.REACT_APP_PAYLOAD, ciphertext);
}

//Authenticating the user from server
function login(userData) {
  const appPayload = {};
  return postRequest("Auth/Login", userData, false, false)
    .then((response) => {
      return responseHandler.handleServerResponse(response);
    })
    .catch((error) => {
      return responseHandler.handleServerResponse(error.response);
    });
}

async function updateUserProfile(data) {
    return formDataPutRequest(
    `Auth/updateUserProfile`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getUserProfile(id) {
  return getRequest(
    `Auth/getUserProfile/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

//Exporting functions for other files
export const userService = {
  login,
  logout,
  handleLoginResponse,
  updateUserProfile,
  getUserProfile
};
